import React from 'react';
import styled from 'styled-components';
import Register from '../components/auth/Register';

// Contenitore principale che occupa esattamente la viewport e impedisce scrolling esterno
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: #1f0b31;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
`;

// Container interno che gestisce lo scrolling se necessario
const ScrollContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
`;

const RegisterPage = () => {
  return (
    <PageContainer>
      <ScrollContainer>
        <Register />
      </ScrollContainer>
    </PageContainer>
  );
};

export default RegisterPage; 